import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IBcActiveContest, IBcContestStudentData, permissions } from '../../../models/BcContest';
import { IPersonSearchResultItem } from '../../../models/Person';

import { AppService } from '../../../services/app.service';
import { BcContestService } from '../../../services/bc-contest.service';
import { MessageService } from '../../../services/message.service';
import { BcContestPreferencesComponent } from '../preferences/bc-contest-preferences.component';
import { helpers, ICourseCard, bcState, getMessageTemplates } from '../shared';

@Component({
    selector: 'app-bc-contest-apply',
    templateUrl: './bc-contest-apply.component.html',
    styleUrls: ['../bc-contest.scss']
})
export class BcContestApplyComponent implements OnInit {
    constructor(
        private app: AppService,
        private service: BcContestService,
        private messages: MessageService,
        private route: ActivatedRoute,
        private modal: NgbModal
    ) {
    }

    contest: IBcActiveContest;
    student: IBcContestStudentData;
    studentData: IBcContestStudentData[] = [];
    courses: ICourseCard[] = [];
    pointsExtraInfoHtml: string;
    hasAgreed: boolean;

    canPickStudent: boolean;
    studentPick: IPersonSearchResultItem;
    upn: string;

    isReady: boolean;
    isStudentPickerOpened: boolean;

    get requiredEcts() {
        return (this.student?.CreditPoints || 0) * 1.5;
    }

    private autoOpenPreferences: boolean;

    ngOnInit() {
        this.autoOpenPreferences = bcState.shouldOpenPreferences();

        this.canPickStudent = this.app.currentUser.hasRight(permissions.setStudent);

        this.upn = this.route.snapshot.queryParams['upn'];

        getMessageTemplates(this.app, this.messages).subscribe(data => {
            this.pointsExtraInfoHtml = data.pointInfo;
        });

        this.init(this.upn);
    }

    selectStudent(student: IBcContestStudentData) {
        this.student = student;

        bcState.setStudentData(student);

        if (student.HasApplied) {
            this.loadCourses();
        }
    }

    pickStudent(person: IPersonSearchResultItem) {
        this.isStudentPickerOpened = false;
        this.studentPick = person;

        this.init(person.Email);
    }

    toggleStudentPicker() {
        this.isStudentPickerOpened = !this.isStudentPickerOpened;

        if (this.isStudentPickerOpened) {
            this.isReady = false;
            this.courses = [];
            this.student = undefined;
            this.studentData = [];
            this.hasAgreed = false;
        }
    }

    apply() {
        this.app.addLoading(this.service.apply(this.contest.Id, this.student.StudentId)).subscribe(id => {
            this.student.Id = id;
            this.student.HasApplied = true;
            this.app.navigate(['/bc-contests/apply/courses'], { queryParams: { studentId: id } });
        });
    }

    editPreferences() {
        const ref = this.modal.open(BcContestPreferencesComponent, { size: 'lg' });

        ref.componentInstance.data = {
            courses: this.courses,
            student: this.student
        };

        ref.closed.subscribe(() => {
            const arr = this.courses.filter(t => !!t.ApplicationId);
            arr.sort((a, b) => a.Priority - b.Priority);

            this.courses = arr;
        });
    }

    onRemove(course: ICourseCard) {
        const ix = this.courses.indexOf(course);
        this.courses.splice(ix, 1);
    }

    private init(upn?: string) {
        const onContest = contest => {
            this.contest = contest;
            bcState.setActiveContest(contest);

            if (contest) {
                const student = bcState.getStudentData();

                if (student && (!upn || student.Upn == upn)) {
                    onStudent([student]);
                } else if (this.canPickStudent && !upn) {
                    this.isReady = true;
                    this.toggleStudentPicker();
                } else {
                    this.app.addLoading(this.service.getStudentData(this.contest.Id, upn)).subscribe(data => {
                        onStudent(data);
                    });
                }
            } else {
                this.isReady = true;
            }
        };

        const onStudent = student => {
            this.studentData = student;

            if (student.length == 1) {
                this.selectStudent(student[0]);
            }

            this.isReady = true;
        };

        const contest = bcState.getActiveContest();

        if (contest) {
            onContest(contest);
        } else {
            this.app.addLoading(this.service.getActive()).subscribe(data => {
                onContest(data);
            });
        }
    }

    private loadCourses() {
        this.app.addLoading(this.service.getStudentCourses(this.student.Id)).subscribe(data => {
            const gc = helpers.groupCourses(data);

            this.courses = gc.courses;

            if (this.autoOpenPreferences) {
                this.editPreferences();
            }
        });
    }
}
